import React, { useEffect, useState } from 'react';
import {
  Container,
  Button,
} from '@mui/material';
import { 
  AddCircleOutline,
} from '@mui/icons-material';
import Card from '../../UI/Cards/ActionLogsCardTimeline';

function ActionLogsTimeline({ data, spinner, handleAction }) {
  const [dataFormatted, setDataFormatted] = useState([]);

  useEffect(() => {
    setDataFormatted(data);
  }, [data]);

  return (
    <>
      <Container style={{ paddingBottom: 30 }}>
        <div style={{ ...styles.cardsContainer, marginTop: data ? '4rem': 0, opacity: spinner ? 0.3 : 1 }}>
          {dataFormatted && dataFormatted.map((doc, index) => (
            <Card
              index={index}
              click={() => handleAction(doc._id)}
              key={doc._id}
              {...doc}
            />
          ))}
        </div>
      </Container>
    </>
  );
}

export default ActionLogsTimeline;

const styles = {
  card: {

  },
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '20px 0',
    color: 'grey',
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 15px',
  },
  list: {
    maxHeight: 300,
    overflowY: 'auto',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    cursor: 'pointer',
  },
  label: {
    color: 'grey',
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 25,
  },
};
